import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CaseCreateWizardComponent } from './case-create-wizard.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
//import {FlexLayoutModule} from '@angular/flex-layout';
import { CaseCreateChildProceduresDialogComponent } from './dialog/case-create-child-procedures-dialog/case-create-child-procedures-dialog.component';

@NgModule({
    declarations: [
        CaseCreateWizardComponent,
        CaseCreateChildProceduresDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatProgressSpinnerModule,
        MatStepperModule,
        MatBadgeModule,
        MatButtonModule,
        MatTooltipModule,
        //FlexLayoutModule,
    ],
    exports: [
        CaseCreateWizardComponent,
    ]
})
export class CaseCreateWizardModule { }
